// Migratie van BEWAARDE filterwaarden naar de huidige benaming.
//
// Filters worden op twee plaatsen bewaard:
//   1. sessionStorage per pagina (`<pagina>.filters`, zie useFilterPersistence)
//   2. de favorieten-tabel `user_filter_favorites` (ook gedeelde favorieten van
//      een andere gebruiker)
// Beide bevatten de LETTERLIJKE filterwaarde. Wordt een status- of filterwaarde
// hernoemd, dan matcht een bewaarde filter niets meer en ziet de gebruiker een
// lege tabel zonder te weten waarom. Daarom vertalen we bij het HERSTELLEN naar
// de huidige waarde; opslaan gebeurt altijd met de nieuwe tekst, dus de
// eerstvolgende filterwijziging schrijft de oude waarde definitief weg.
//
// Bij elke toekomstige rename van een filterwaarde: één regel toevoegen aan
// LEGACY_FILTER_VALUES (en de bijhorende test).

// Customer Payment Status-toestand "oninbaar deel" (clawback-correctie).
export const PAY_STATUS_PARTIAL = 'Wanbetaler – oninbaar deel';

// Verouderde waarde → huidige waarde. Match op de WAARDE, niet op de veldnaam:
// elke pagina heeft eigen filternamen (detailCpsFilter, sbCpsFilter,
// customerPaymentStatusFilter, paymentStatusFilter, …).
export const LEGACY_FILTER_VALUES = [
  // 30-07-2026: "Wanbetaler – deels oninbaar" → "Wanbetaler – oninbaar deel".
  // Streepje-tolerant: oudere snapshots kunnen een gewoon koppelteken bevatten.
  { match: /^wanbetaler\s*[-–—]\s*deels\s+oninbaar$/i, value: PAY_STATUS_PARTIAL },
];

// Vertaalt verouderde filterwaarden in een bewaarde snapshot naar de huidige.
// Recursief over objecten/arrays (multi-select-filters bewaren een array).
// Onbekende waarden blijven ongemoeid → veilig voor elke pagina-snapshot.
export function migrateSavedFilters(node) {
  if (typeof node === 'string') {
    const hit = LEGACY_FILTER_VALUES.find(r => r.match.test(node));
    return hit ? hit.value : node;
  }
  if (Array.isArray(node)) return node.map(migrateSavedFilters);
  if (node && typeof node === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(node)) out[k] = migrateSavedFilters(v);
    return out;
  }
  return node;
}
